import React from 'react';
import { FormGroup, Alert } from 'react-bootstrap';
import {
  FormControl,
  Button,
} from '../form/FormControls.jsx';
import { CenterBox } from '../../util/util.jsx';
import { connect } from 'react-redux';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import './auth.css';
import { Header } from '@/component/header/Header.jsx';
import {loadUserData, updatePassword} from "../../store/passwordReset.store";
import LoadingScreenComponent from '@/component/loadingscreen/LoadingScreen';

const mapStateToProps = (state) => ({
  error: state.getIn(['passwordReset', 'error']),
  formError: state.getIn(['passwordReset', 'form-error']),
  user: state.getIn(['passwordReset', 'user_data']),
  isLoading: state.getIn(['storeStatus', 'isLoading'], false),
});

const mapDispatchToProps = (dispatch) => ({
  updatePassword: (token, password, repeatPassword, mfaCode) =>
    updatePassword(dispatch, token, password, repeatPassword, mfaCode),
  loadUserData: (token) => loadUserData(dispatch, token)
});

class PasswordChangeClass extends React.Component {
  constructor(args) {
    super(args);
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.handleRepeatPasswordChange = this.handleRepeatPasswordChange.bind(this);
    this.handleMfaCode = this.handleMfaCode.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.state = {
      password: '',
      repeatPassword: '',
      mfaCode: null,
    };
  }

  componentWillMount() {
    this.props.loadUserData(window.location.pathname.split("/")[2]);
  }

  onSubmit(event) {
    event.preventDefault();
    this.props.updatePassword(window.location.pathname.split("/")[2],
      this.state.password,
      this.state.repeatPassword,
      this.state.mfaCode
    );
  }

  handlePasswordChange(event) {
    this.setState({ password: event.target.value });
  }

  handleRepeatPasswordChange(event) {
    this.setState({ repeatPassword: event.target.value });
  }

  handleMfaCode(event) {
    this.setState({ mfaCode: event.target.value });
  }

  render() {
    const pn = window.location.pathname.split("/");
    if (pn.length < 3) {
        return <div>No token is present</div>
    }
    if (this.props.error) {
      return <ReactCSSTransitionGroup
        transitionName="example" transitionEnterTimeout={500} transitionLeaveTimeout={300}
      >
        {this.props.error ?
          <Alert bsStyle="default" className="has-error" style={{ padding: 0 }}>
            <div className="help-block" style={{ fontSize: 'medium' }}>
              {this.props.error}
            </div>
          </Alert> :
          ''
        }
      </ReactCSSTransitionGroup>
    }
    if (!this.props.user) {
      return  <div><Header loginScreen />
                <CenterBox
                  width="500px" height="300px"
                  style={{ paddingTop: '56px', background: '#f0f0f0' }}
                >
                  <FormGroup>
                    <center>
                      <h4>
                        Waiting for user data
                      </h4>
                    </center>
                  </FormGroup>
                </CenterBox>
              </div>
    }
    return (
      <div>
        <Header loginScreen />
        <LoadingScreenComponent loading={this.props.isLoading}>
        <CenterBox
          width="500px" height="300px"
          style={{ paddingTop: '56px', background: '#f0f0f0' }}
        >
          <form
            onSubmit={this.onSubmit}
            style={{ padding: '20px 80px', background: 'white', border: 'thin solid lightgray' }}
          >
            <FormGroup>
              <center>
                <h4>
                  Set new password for {this.props.user.get('email')}
                </h4>
              </center>
            </FormGroup>
            <FormGroup>
              <FormControl
                type="password" name="password" placeholder="Enter your new password here"
                value={this.state.password} onChange={this.handlePasswordChange}
              />
            </FormGroup>
            <FormGroup>
              <FormControl
                type="password" name="password" placeholder="Repeat your new password here"
                value={this.state.repeatPassword} onChange={this.handleRepeatPasswordChange}
              />
            </FormGroup>
            <FormGroup>
              <FormControl
                type="text" name="mfa" placeholder="MFA code"
                value={this.state.mfaCode} onChange={this.handleMfaCode}
                maxLength="6"
              />
            </FormGroup>
            <FormGroup>
              <Button
                id="signin"
                type="submit"
                bsStyle="primary"
                style={{ width: '100%' }}
              >
                Update password
              </Button>
            </FormGroup>
            {this.props.formError ?
              <Alert bsStyle="default" className="has-error" style={{ padding: 0 }}>
                <div className="help-block" style={{ fontSize: 'medium' }}>
                  {this.props.formError}
                </div>
              </Alert> :
              ''}
          </form>
        </CenterBox>
        </LoadingScreenComponent>
      </div>);
  }
}
PasswordChangeClass.propTypes = {
  isLoading: React.PropTypes.bool,
  error: React.PropTypes.string,
  formError: React.PropTypes.string,
  updatePassword: React.PropTypes.func,
  user: React.PropTypes.object,
  loadUserData: React.PropTypes.func
};

export const PasswordChange = connect(mapStateToProps, mapDispatchToProps)(PasswordChangeClass);
